import { ref } from 'vue'

export const devFetchDelayEnabled = ref(false)
export const devFetchDelayValue = ref<number>(1.0) // Default 1 second, range 0.5-8
export const devFetchErrorCode = ref<number | string>('')

// Optionally, add helpers to reset
export function resetDevFetchInterception() {
  devFetchDelayEnabled.value = false
  devFetchDelayValue.value = 1.0
  devFetchErrorCode.value = ''
}
